import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { InertiaPlugin } from 'gsap/InertiaPlugin';
import { Draggable } from 'gsap/Draggable';

gsap.registerPlugin(ScrollTrigger, Draggable);

const interpolateProgress = (startValue, endValue, progress) => {
  const value = startValue + (endValue - startValue) * progress;
  const min = Math.min(startValue, endValue);
  const max = Math.max(startValue, endValue);
  const clamped = Math.max(min, Math.min(max, value));
  return clamped.toFixed(1);
};

const setup = () => {
  const sliders = gsap.utils.toArray('[data-w-value-slider]');
  if (sliders) {
    sliders.forEach((slider) => {
      const sliderHandle = slider.querySelector('[data-w-value-slider-handle]');
      const sliderParent = slider.closest('[data-w-value-slider-parent]');
      const sliderPercent = sliderParent.querySelector(
        '[data-w-value-slider-percent]'
      );
      const sliderValue = sliderParent.querySelector(
        '[data-w-value-slider-value]'
      );
      const [startValue, endValue] = sliderValue
        .getAttribute('data-w-value-slider-value')
        .split('|')
        .map(parseFloat);

      const sliderContext = slider.closest('.w-b-tower-scroll-scene');

      gsap.set(sliderContext, {
        '--_slider-progress': `0%`,
        '--_scroll-color-dark': `color-mix(in srgb, var(--color-green-dark) var(--_slider-progress), var(--color-cool-gray-light) calc(100% - var(--_slider-progress)))`,
        '--_scroll-color': `color-mix(in srgb, var(--color-green) var(--_slider-progress), var(--color-cool-gray) calc(100% - var(--_slider-progress)))`,
        '--_scroll-background-color': `color-mix(in srgb, var(--color-bg-green) var(--_slider-progress), var(--color-bg-blue) calc(100% - var(--_slider-progress)))`,
      });

      const sliderMovement = gsap.to(sliderHandle, {
        scrollTrigger: {
          trigger: sliderParent,
          start: 'top 90%',
          end: 'center 40%',
          scrub: true,
          onUpdate: (self) => {
            const progress = gsap.parseEase('power2.inOut')(self.progress);
            const maxX = Math.max(
              0,
              slider.clientWidth - sliderHandle.clientWidth
            );
            gsap.set(sliderHandle, { x: maxX * progress });
            gsap.set(sliderContext, {
              '--_slider-progress': `${progress * 100}%`,
            });
            sliderPercent.textContent = `${Math.round(progress * 100)}%`;
            sliderValue.textContent = interpolateProgress(
              startValue,
              endValue,
              progress
            );
          },
        },
      });
      const update = (progress) => {
        gsap.set(sliderContext, {
          '--_slider-progress': `${progress * 100}%`,
        });
        sliderPercent.textContent = `${Math.round(progress * 100)}%`;
        sliderValue.textContent = interpolateProgress(
          startValue,
          endValue,
          progress
        );
      };
      const draggable = Draggable.create(sliderHandle, {
        type: 'x',
        bounds: slider,
        onDragStart: () => {
          sliderMovement.scrollTrigger.disable();
        },
        onMove: function () {
          let progress = (this.x - this.minX) / (this.maxX - this.minX || 1);
          progress = Math.max(0, Math.min(1, progress));
          // progress = gsap.parseEase('power1.inOut')(progress);

          update(progress);
        },
      });
      slider.addEventListener('click', (e) => {
        sliderMovement.scrollTrigger.disable();
        const width = slider.clientWidth;
        gsap.to(sliderHandle, {
          duration: 0.4,
          x: e.offsetX,
          ease: 'power3.out',
          onUpdate: function () {
            const x = gsap.getProperty(sliderHandle, 'x');
            console.log(x);
            const progress = Math.max(0, Math.min(1, x / width));
            update(progress);
          },
        });
      });
    });
  }
};

export default function ValueSlider() {
  return {
    init: () => {
      setup();
    },
  };
}
